// namespace (소문자)
export const NAMESPACE = 'user';
//actions
export const USER_RESET_STATE = 'USER_RESET_STATE';
export const USER_UPDATE = 'USER_UPDATE';
export const USER_UPDATE_ME = 'USER_UPDATE_ME';
export const OWNER_UPDATE_ME = 'OWNER_UPDATE_ME';
export const OWNER_SYNC_ME = 'OWNER_SYNC_ME';
export const OWNER_SYNC = 'OWNER_SYNC';
export const FETCH_OWNER = 'FETCH_OWNER';
export const USER_PUBLISH = 'USER_PUBLISH';
export const USER_DELETE = 'USER_DELETE';
export const USER_DELETE_ME = 'USER_DELETE_ME';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const UPDATE_PASSWORD_ME = 'UPDATE_PASSWORD_ME';
export const RESET_PASSWORD_UPDATED_AT = 'RESET_PASSWORD_UPDATED_AT';
export const FETCH_MAIN = 'FETCH_MAIN';
export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_OWNERS = 'FETCH_OWNERS';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_ME = 'FETCH_ME';
export const UPDATE_NICKNAME = 'UPDATE_NICKNAME';
export const LEAVE = 'LEAVE';
export const UPDATE_USER_DEVICE_INFO = 'UPDATE_USER_DEVICE_INFO';
export const DELETE_USER_DEVICE_INFO = 'DELETE_USER_DEVICE_INFO';
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
export const FIND_USER_ID = 'FIND_USER_ID';
export const FIND_PASSWORD = 'FIND_PASSWORD';
export const FIND_USER_BY_MOBILE_NUMBER = 'FIND_USER_BY_MOBILE_NUMBER';
export const FIND_USER_BY_USER_ID = 'FIND_USER_BY_USER_ID';
export const UPDATE_MOBILE_NUMBER_ME = 'UPDATE_MOBILE_NUMBER_ME';
export const UPDATE_EMAIL_ME = 'UPDATE_EMAIL_ME';
export const EXIST_EMAIL = 'EXIST_EMAIL';
export const EXIST_NICKNAME = 'EXIST_NICKNAME';
export const UPDATE_AREA_ME = 'UPDATE_AREA_ME';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const EXCEL_DOWNLOAD_USERS = 'EXCEL_DOWNLOAD_USERS';
export const EXCEL_DOWNLOAD_OWNERS = 'EXCEL_DOWNLOAD_OWNERS';
export const UPDATE_SCREEN_ACTIVED = 'UPDATE_SCREEN_ACTIVED';
export const UPDATE_CURRENT_AREA = 'UPDATE_CURRENT_AREA';
export const FETCH_AUTH_AREA_ME = 'FETCH_AUTH_AREA_ME';
export const FETCH_AUTH_AREA = 'FETCH_AUTH_AREA';
export const FETCH_USER_STATUS = 'FETCH_USER_STATUS';
export const UPDATE_USER_TELECOM_DEVICE = 'UPDATE_USER_TELECOM_DEVICE';
export const UPDATE_USER_TELECOM_AND_DEVICE = 'UPDATE_USER_TELECOM_AND_DEVICE';
export const FETCH_USER_DEVICE = 'FETCH_USER_DEVICE';
export const COUNSEL_UPDATE = 'COUNSEL_UPDATE';
export const SELECT_USER_INFO = 'SELECT_USER_INFO';
export const FETCH_VIOLATION_ME = 'FETCH_VIOLATION_ME';
export const USER_REPORT = 'USER_REPORT';
export const FETCH_USER_CURRENT_AREA = 'FETCH_USER_CURRENT_AREA';
export const SET_USER_CURRENT_AREA = 'SET_USER_CURRENT_AREA';

//mutations
export const SET_USERS = 'SET_USERS';
export const SET_OWNERS = 'SET_OWNERS';
export const SET_USER = 'SET_USER';
export const SET_USER_MAIN = 'SET_USER_MAIN';
export const SET_USER_EMAIL = 'SET_USER_EMAIL';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_OWNER_PROFILE = 'SET_OWNER_PROFILE';
export const SET_AUTH_AREA = 'SET_AUTH_AREA';
export const SET_AREA_HISTORY = 'SET_AREA_HISTORY';
export const SET_USER_STATUS = 'SET_USER_STATUS';
//getter
export const USERS = 'USERS';
export const OWNERS = 'OWNERS';
export const USERS_ISLOADING = 'USERS_ISLOADING';
export const USERS_COUNT = 'USERS_COUNT';
export const USER = 'USER';
export const USER_MAIN = 'USER_MAIN';
export const OWNER = 'OWNER';
export const USER_AUTH_AREA = 'USER_AUTH_AREA';
export const USER_STATUS = 'USER_STATUS';

export const getName = name => `${NAMESPACE}/${name}`;
export const ROOT_UPDATE_CURRENT_AREA = getName(UPDATE_CURRENT_AREA);
export const ROOT_UPDATE_USER_DEVICE_INFO = getName(UPDATE_USER_DEVICE_INFO);
